import { Routes } from '@angular/router';

export const CHILD_ONBOARDING_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
    data: { shouldHideHeaderAndFooter: true },
  },
  {
    path: 'person',
    loadComponent: () => import('./pages/person/person.component').then((m) => m.PersonComponent),
  },
  {
    path: 'wohnsitz',
    loadComponent: () => import('./pages/residence/residence.component').then((m) => m.ResidenceComponent),
  },
  {
    path: 'mobilfunknummer',
    loadComponent: () => import('./pages/mobile-number/mobile-number.component').then((m) => m.MobileNumberComponent),
  },
  {
    path: 'staatsangehoerigkeit',
    loadComponent: () => import('./pages/nationality/nationality.component').then((m) => m.NationalityComponent),
  },
  {
    path: 'referenzkonto',
    loadComponent: () => import('./pages/bank-account/bank-account.component').then((m) => m.BankAccountComponent),
  },
  {
    path: 'identifikation',
    loadComponent: () => import('./pages/document-upload/document-upload.component').then((m) => m.DocumentUploadComponent),
  },
  {
    path: 'weiterer-sorgeberechtigter',
    loadComponent: () => import('./pages/legal-guardian-2/legal-guardian-2.component').then((m) => m.LegalGuardian2Component),
  },
  {
    path: 'email',
    loadComponent: () => import('./pages/sign-up/sign-up.component').then((m) => m.SignUpComponent),
  },
  {
    path: 'email-bestaetigen',
    loadComponent: () => import('./pages/email-confirmation/email-confirmation.component').then((m) => m.EmailConfirmationComponent),
  },
  {
    path: 'bestaetigung',
    loadComponent: () =>
      import('./pages/legal-guardian-2-confirmation/legal-guardian-2-confirmation.component').then(
        (m) => m.LegalGuardian2ConfirmationComponent,
      ),
  },
  {
    path: 'weiterleitung',
    loadComponent: () => import('./pages/redirect/redirect.component').then((m) => m.RedirectComponent),
  },
  {
    path: 'vertragsabschluss',
    loadComponent: () =>
      import('./pages/conclusion-of-contract/conclusion-of-contract.component').then((m) => m.ConclusionOfContractComponent),
  },
];
